{
  "label": "Shot",
  "labelWithScene": "Shot {{scene}}.{{number}}",
  "labelWithNumber": "Shot {{number}}",
  "transitionShot": "Transition shot {{number}}",
  "noDescription": "No description",
  "draft": {
    "badge": "Draft 480p",
    "to1080p": "To 1080p",
    "segmentHint": "This video was a draft, so it can be regenerated at 1080p while keeping the composition.",
    "finalize": "Finalize",
    "dialogTitle": "Finalize draft",
    "daysLeft": "Available for {{count}} more days",
    "regenerateNote": "This regenerates the video from the draft at the chosen resolution. The draft stays in the version list.",
    "unavailable": "This draft cannot be finalized right now.",
    "failed": "Could not start finalize."
  },
  "nav": {
    "prevWithSummary": "Shot {{number}} — {{summary}}",
    "prevNumberOnly": "Shot {{number}}",
    "noPrev": "No previous shot",
    "noNext": "No next shot"
  },
  "panel": {
    "title": "{{base}} — Generation",
    "editShot": "Edit shot",
    "loadFailed": "Could not load project data",
    "frameFormat": "Frame format",
    "frameFormatHint": "Format for this shot’s new generations. The shot panel preview uses this format right away; project assembly stays in the project format. Existing frames keep their aspect ratio.",
    "changeFrameFormat": "Change shot format",
    "videoModel": "Video model",
    "videoModelHint": "Generation model for this shot. Empty means inherit the project setting.",
    "changeVideoModel": "Change video model",
    "videoResolution": "Video resolution",
    "videoResolutionHint": "Output resolution for this shot. Empty means inherit the project setting for the current model.",
    "changeVideoResolution": "Change video resolution",
    "draft": "Draft",
    "draftOnHint": "Draft is on. The next video will be a 480p draft. Click to generate a normal video.",
    "draftOffHint": "Draft is off. Click to make the next video a 480p draft.",
    "back": "Back",
    "backTo": "Back to {{place}}",
    "backToShot": "Back to shot",
    "returnPlace": {
      "storyboard": "storyboard",
      "generations": "generations",
      "animatics": "animatics",
      "library": "library",
      "assembly": "assembly",
      "overview": "overview",
      "canvas": "canvas",
      "studio": "studio",
      "seasons": "seasons",
      "script": "script",
      "characters": "characters",
      "locations": "locations",
      "props": "props",
      "cameras": "cameras",
      "presets": "presets",
      "skills": "skills"
    }
  },
  "firstGenResolutionConfirm": {
    "title": "First video generation",
    "message": "For the first generation, try {{resolution}} — it is faster and cheaper. You can regenerate at a higher resolution later.",
    "generateMin": "Generate {{resolution}}",
    "generateAt": "Generate at {{resolution}}"
  },
  "videoMissingFrameConfirm": {
    "title": "Key frame is not ready yet",
    "message": "This shot does not have a key frame yet. Without it, the model will rely only on the prompt and reference materials. Continue generating video without a key frame?",
    "confirm": "Generate video without frame"
  },
  "videoPrevizConfirm": {
    "title": "Previz is not included",
    "message": "This shot has a previz, but it will not be sent with the generation. Generate the video with the previz or without it?",
    "with": "Include previz",
    "without": "Without previz"
  },
  "videoAnimaticConfirm": {
    "title": "Animatic is not included",
    "message": "This shot has an animatic, but it will not be sent with the generation. Generate the video with the animatic or without it?",
    "with": "Include animatic",
    "without": "Without animatic"
  },
  "sidebar": {
    "assistant": "Assistant and prompts",
    "preview": "Prompts",
    "characters": "Characters",
    "location": "Location",
    "props": "Props",
    "transcription": "Transcription",
    "storyboard_versions": "Frame versions",
    "shooting_board_versions": "Shooting board",
    "video_versions": "Video versions",
    "post_production_versions": "Processing",
    "flow": "Flow"
  },
  "tabs": {
    "transition": "Transition",
    "storyboard": "Key frame",
    "video": "Video",
    "shootingBoard": "Shooting board",
    "animatic": "Animatic",
    "previz": "Previz",
    "unseenAfterGeneration": "New content after generation"
  },
  "previz": {
    "assign": "Set as shot previz",
    "replace": "Upload",
    "replaceTitle": "Replace previz?",
    "replaceMessage": "This shot already has a linked previz. The new previz will replace the current one (the file stays in the library).",
    "replaceConfirm": "Replace",
    "pickFromLibrary": "From library",
    "record": "Record previz",
    "preparingTitle": "Previz: Scene {{scene}} shot {{number}}",
    "preparingTitleShort": "Previz: shot {{number}}",
    "recordHint": "Record a camera flythrough in a 3D scene",
    "selectScene": "Choose 3D scene",
    "createScene": "Create 3D scene",
    "pickerTitle": "Choose 3D scene",
    "pickerSearch": "Search 3D scenes…",
    "pickerClose": "Close",
    "pickerLoading": "Loading…",
    "pickerEmpty": "No 3D scenes",
    "pickerNoResults": "No results",
    "pickerUnlocated": "No location",
    "defaultSceneName": "Scene",
    "unlink": "Detach",
    "linkFailed": "Could not link the previz.",
    "pickFailed": "Could not set the shot previz.",
    "videoMissing": "The previz video is unavailable.",
    "uploadHint": "Drop a previz video here",
    "uploadHintDetail": "or choose a file (webm/mp4), pick a video from the library, or record a flythrough in the 3D scene",
    "uploadButton": "Upload file",
    "send": "Send previz",
    "sendHint": "The shot previz goes into generation: the camera flythrough or a depth mask — whichever is selected below (up to {{max}} s).",
    "sendTooLong": "The previz exceeds the video reference limit: {{duration}} s with a maximum of {{max}} s.",
    "sendTranscodePending": "The previz is still converting to mp4 — generation will wait for it to finish.",
    "sendTranscodeFailed": "Could not prepare the previz mp4. Re-save the previz and try again.",
    "noLinked": "No previz is linked to this shot — add one on the Previz tab.",
    "sendOriginalTitle": "Original",
    "sendOriginalDesc": "The camera flythrough is sent as reference_video: movement, framing, and timing come from the previz.",
    "sendDepthBwTitle": "Depth mask (black and white)",
    "sendDepthBwDesc": "Use the black-and-white depth map. Brightness shows distance from the camera, not light or style.",
    "sendDepthColorTitle": "Depth mask (color)",
    "sendDepthColorDesc": "Use the color depth map. Color shows distance from the camera, not light or style.",
    "depthNeedsGenerate": "Generate the depth mask on the Previz tab first.",
    "depthGray": "Black and white",
    "depthColor": "Color",
    "viewClip": "Previz",
    "viewDepth": "Depth mask",
    "depthNotGenerated": "Depth mask not generated yet.",
    "depthGenerate": "Generate",
    "depthGenerating": "Computing the depth mask…",
    "depthGenerateFailed": "Could not start the depth mask.",
    "depthNeedsMp4": "Wait for the previz mp4 to finish first."
  },
  "composerTabs": {
    "frame": "Frame",
    "video": "Video",
    "assistant": "Assistant",
    "transitionEmpty": "Transition shots have no frame prompt"
  },
  "promptTabs": {
    "storyboard": "Key frame prompt",
    "video": "Video prompt",
    "shooting_board": "Shooting board prompt",
    "animatic": "Animatic",
    "previz": "Previz"
  },
  "player": {
    "timecode": "Timecode (hours:minutes:seconds:frames)",
    "toStart": "Go to start (Home)",
    "toEnd": "Go to end (End)",
    "frameBack": "Previous frame (←)",
    "frameForward": "Next frame (→)",
    "play": "Play (Space / L)",
    "pause": "Pause (Space / K)",
    "loop": "Loop",
    "pip": "Picture in picture",
    "pipPreviz": "Previz",
    "pipAnimatic": "Animatic",
    "audioScrub": "Audio while scrubbing",
    "fullscreen": "Fullscreen",
    "exitFullscreen": "Exit fullscreen",
    "mute": "Mute",
    "unmute": "Unmute",
    "volume": "Volume",
    "shortcutsAria": "Keyboard shortcuts",
    "shortcutsTitle": "Keyboard shortcuts",
    "shortcutsPlayback": "Playback",
    "shortcutsSeek": "Seek",
    "shortcutsEdit": "Edit",
    "shortcutsView": "View",
    "shortcutPlayPause": "Play / pause",
    "shortcutReverse": "Reverse (repeat doubles speed up to 4×)",
    "shortcutPause": "Pause",
    "shortcutPlayForward": "Play forward (repeat doubles speed up to 8×)",
    "shortcutFrameBack": "Previous frame",
    "shortcutFrameForward": "Next frame",
    "shortcutSeekBack": "Seek −1 second",
    "shortcutSeekForward": "Seek +1 second",
    "shortcutToStart": "Go to start",
    "shortcutToEnd": "Go to end"
  },
  "timeline": {
    "saveFailed": "Could not save the timeline",
    "snapping": "Snapping (align to clip edges)",
    "blade": "Blade at playhead (B)",
    "deleteClip": "Delete selected clip (Del)",
    "shortcutBlade": "Blade at playhead",
    "shortcutDeleteClip": "Delete selected clip",
    "shortcutRateStretch": "Rate-stretch clip edge (change speed)",
    "shortcutZoom": "Zoom timeline",
    "speed": "Clip speed",
    "speedHint": "Playback speed of the selected clip. Alt+drag a clip edge changes speed without trimming.",
    "speedReset": "Reset to 1x",
    "addTrack": "Add track",
    "addVideoTrack": "Video track (shot version)",
    "addAnimaticTrack": "Animatic",
    "addCorrectionTrack": "Correction",
    "addAudioTrack": "Audio track",
    "pickAudioTrack": "Pick a track",
    "emptyAudioTrack": "Empty track",
    "audioAssetFallback": "Audio",
    "correctionTrackHint": "Correction track",
    "openCorrection": "Open correction",
    "pickVersion": "Pick a shot version",
    "pickAnimatic": "Animatic",
    "animaticVideoWithAudio": "Video with sound",
    "animaticVideoOnly": "Video only",
    "animaticAudioOnly": "Audio only",
    "animaticTrackLabel": "Animatic",
    "animaticUnavailable": "No animatic",
    "activeVersion": "active",
    "render": "Render",
    "renderHint": "Render the timeline into a new shot video version",
    "renderStarted": "Render started",
    "renderFailed": "Could not start the render",
    "lipsyncHint": "Lipsync: select one video clip and one audio clip (cmd+click)",
    "lipsyncStarted": "Lipsync started — the clips are locked until it finishes",
    "lipsyncFailed": "Could not start lipsync",
    "versionAudioLabel": "Version audio",
    "versionAudioNamed": "a{{n}}",
    "renameVersion": "Rename version",
    "renameFailed": "Failed to rename version",
    "customAudioLabel": "Audio",
    "videoTrackLabel": "Video",
    "muteTrack": "Mute track",
    "unmuteTrack": "Unmute track",
    "trackVolume": "Track volume",
    "volumeOff": "Off",
    "hideTrack": "Hide layer",
    "showTrack": "Show layer",
    "dragToReorder": "Drag to reorder tracks",
    "detachAudio": "Detach audio to a separate track",
    "audioDetached": "Audio detached",
    "deleteTrack": "Delete track",
    "record": "Record from microphone",
    "tts": "Text to speech",
    "uploadAudio": "Upload an audio file",
    "audioInput": "Audio input",
    "defaultMicrophone": "Default microphone",
    "defaultInputNamed": "Default — {{name}}",
    "microphoneN": "Microphone {{n}}",
    "systemAudio": "Tab or screen audio",
    "systemAudioMissing": "No audio captured: tick “Share audio” in the picker dialog (works in Chrome and Edge)",
    "systemAudioCancelled": "Source selection cancelled",
    "microphoneUnavailable": "Selected microphone is unavailable — recording from the default input",
    "keepOriginalVoice": "Keep original voice",
    "voiceChangeElevenLabsOnly": "Voice change is available for ElevenLabs voices only.",
    "voice": "Voice",
    "playVideoWithRecording": "Play the video when recording starts",
    "startRecording": "Start recording",
    "stopRecording": "Stop recording",
    "rec": "REC",
    "cancel": "Cancel",
    "recordAgain": "Record again",
    "recordTrackLocked": "A clip on this track is frozen by lipsync. Wait until it finishes.",
    "recordingTooShort": "The recording is too short",
    "recordingPermissionDenied": "Microphone access denied",
    "ttsPlaceholder": "Text to speak…",
    "generate": "Generate",
    "assetFailed": "Could not process the audio",
    "processingAudio": "Processing audio…"
  },
  "common": {
    "provider": "Provider:",
    "loading": "Loading…",
    "loadingPrompts": "Loading prompts…",
    "loadingPrompt": "Loading prompt…",
    "loadingFrameData": "Loading frame data…",
    "networkUnavailable": "Network unavailable.",
    "sessionExpired": "Session expired — refresh the page.",
    "sessionExpiredRetry": "Session expired — refresh the page and try again.",
    "saved": "Saved",
    "saveFailed": "Failed to save",
    "retry": "Retry",
    "upload": "Upload",
    "uploadOwn": "Upload your own",
    "close": "Close",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "savedState": "Saved",
    "saveErrorRetry": "Error — retry",
    "submitting": "Submitting…",
    "improving": "Improving…",
    "improve": "Improve",
    "edit": "Edit",
    "copy": "Copy",
    "downloadOriginal": "Download original",
    "downloadVideo": "Download video",
    "regenerate": "Regenerate",
    "correct": "Correct",
    "correctVideo": "Correct video",
    "generateVideo": "Generate video",
    "generateDraft": "Generate draft",
    "generateFrame": "Generate frame",
    "generateShootingBoard": "Generate shooting board",
    "generateFromVideoPrompt": "From video prompt text (project image provider)",
    "noFrame": "No frame",
    "first": "First",
    "last": "Last",
    "poster": "Poster",
    "frameNotReady": "Frame not ready yet",
    "showShot": "Show shot",
    "hideShot": "Hide shot",
    "delete": "Delete",
    "deleteConfirm": "Delete permanently?",
    "yesDelete": "Yes, delete",
    "shotShown": "Shot shown",
    "shotHidden": "Shot hidden",
    "shotDeleted": "Shot deleted",
    "originalCopied": "Original copied to clipboard",
    "copyImageFailed": "Failed to copy image",
    "copyClipboardFailed": "Failed to copy to clipboard",
    "panelCount": "Panel count",
    "multishot": "Multishot",
    "duration": "Duration",
    "durationAuto": "Auto",
    "videoDuration": "Video duration",
    "extractFrames": "Extract frames",
    "framesNotExtracted": "Frames not extracted",
    "videoFrames": "Video frames",
    "unlinkSegment": "Detach",
    "downloadSegment": "Download segment",
    "downloadSegmentPreparing": "Preparing segment…",
    "downloadSegmentFailed": "Could not prepare the segment.",
    "segmentPosition": "Segment #{{position}}",
    "referenceClipNotCreated": "Reference clip not created yet",
    "pickAnimaticFromLibrary": "Pick from library",
    "assignAnimaticSegment": "Set as shot animatic",
    "linkSegmentFailed": "Failed to set the shot animatic",
    "uploadAnimaticHint": "Upload an animatic here or pick a video from the library",
    "uploadAnimaticHintDetailBefore": "A file uploaded here stays on this shot and does not join the episode reel. You can also link a segment from ",
    "uploadAnimaticHintDetailLink": "Animatics",
    "uploadAnimaticHintDetailAfter": ".",
    "noAnimaticSegment": "No animatic segment linked to this shot.",
    "sliceFromAnimatic": "Slice from animatic",
    "updateFromAnimatic": "Update from animatic",
    "buildStripToShootingBoard": "Build strip into shot shooting board",
    "animaticStripHint": "Strip of frames from the animatic segment (like MP4 reference). You can rebuild with a different panel count.",
    "animaticFramesHint": "Frames from the animatic segment window (like MP4 reference), evenly spaced in time.",
    "resetToTemplate": "Reset to template",
    "resetStoryboardConfirm": "Reset frame prompts to server templates?",
    "resetVideoConfirm": "Reset video prompts to server templates?",
    "toTemplate": "To template",
    "insertTemplate": "Insert template",
    "insertTemplateTitle": "Insert server template (video system block + frame + motion)",
    "matchesTemplate": "Text already matches template",
    "promptHistory": "Prompt history",
    "improvePrompt": "Improve prompt",
    "systemPrompt": "System prompt",
    "systemPromptVideo": "Video system prompt",
    "systemPromptShootingBoard": "Shooting board system prompt",
    "framePrompt": "Frame prompt",
    "videoPrompt": "Video prompt",
    "shootingBoardPrompt": "Shooting board prompt",
    "shootingBoardPanelCountLabel": "Panel count",
    "shootingBoardPanelCount_one": "{{count}} panel",
    "shootingBoardPanelCount_other": "{{count}} panels",
    "shootingBoardAutoHint": "Shooting board generation prompt is assembled automatically on the server and cannot be edited.",
    "addLocationDescription": "Add location description",
    "addHeroDescription": "Add character description",
    "addPropsDescription": "Add props description",
    "generationSettings": "Settings",
    "extraReferences": "Extra references for frame generation",
    "sendCurrentAsReference": "Send current version as reference",
    "sendCurrentAsReferenceHint": "The current frame preview will be included in the request along with other references (after characters, location, and your @reference_n).",
    "addAnimaticFrameReference": "Add animatic frame as reference",
    "addAnimaticFrameReferenceHint": "A separate system prompt will be added for the selected frame: black-and-white sketch — composition only.",
    "activeVideoMarkers": "Active video version markers (timecodes)",
    "sendAnimaticSegment": "Send animatic segment",
    "sendAnimaticSegmentHint": "A trimmed fragment (up to {{max}} s) and a camera/editing prompt block will be added to the request. Trimming runs in the background.",
    "sendAnimaticSegmentHintShort": "Video reference for generation; trimming in the background after save.",
    "sendAnimaticSegmentTooLong": "Segment is {{duration}} s. It will be trimmed to {{max}} s — the maximum allowed for the current model's video reference.",
    "sendAnimaticSegmentTooShort": "Segment is {{duration}} s. It will be extended with a freeze of the last frame to {{min}} s — the minimum allowed for the current model's video reference.",
    "sendShootingBoardReference": "Send shooting board as reference",
    "videoConsiderScale": "Consider character scale",
    "videoConsiderScaleHintBefore": "Attach the shot ",
    "videoConsiderScaleHintBeforeCompact": "Attach ",
    "videoConsiderScaleHintLink": "character scale sheet",
    "videoConsiderScaleHintAfter": " (when two or more heroes).",
    "videoConsiderScaleDisabled": "Requires at least two heroes in the shot.",
    "videoConsiderScaleFiguresIncomplete": "Some objects have no scale-sheet image and will not be included.",
    "videoConsiderPropScale": "Consider prop scale",
    "videoConsiderPropScaleHintBefore": "Attach the shot ",
    "videoConsiderPropScaleHintLink": "prop scale sheet",
    "videoConsiderPropScaleHintAfter": " (when two or more props with size).",
    "videoConsiderPropScaleDisabled": "Requires at least two props with set diagonal size in the shot.",
    "videoConsiderMixedScale": "Consider scale",
    "videoConsiderMixedScaleHintBefore": "Attach the shot ",
    "videoConsiderMixedScaleHintBeforeCompact": "Attach ",
    "videoConsiderMixedScaleHintLink": "mixed scale sheet",
    "videoConsiderMixedScaleHintAfter": " (heroes and props on one baseline).",
    "mixedScaleSheetTitle": "Scale sheet",
    "mixedScaleSheetLoadError": "Failed to load mixed scale sheet",
    "mixedScaleSheetNeedTwo": "Need at least one hero and one prop with a set size.",
    "mixedScaleSheetApplyAll": "Apply all",
    "mixedScaleSheetHeightLabel": "Size",
    "mixedScaleSheetRegenerateScalePose": "Regenerate A-pose",
    "mixedScaleSheetRegenerateFrontView": "Regenerate front view",
    "mixedScaleSheetScalePoseRequired": "Generate a character sheet or reference sheet first",
    "shootingBoardSeedanceOnly": "Available only with Seedance video engine (OpenRouter / BytePlus Seedance provider). Current provider does not pass shooting board to generation.",
    "shootingBoardReferenceHint": "Shooting board image goes to Seedance references; prompt instructs to follow panel order and frames.",
    "seedanceAdaptiveDuration": "Auto duration (follow video reference)",
    "seedanceAdaptiveDurationHint": "Sends duration -1 / adaptive ratio so the output follows the input video (Seedance 2.x editing tasks). Applies only when the generation includes a video reference — an animatic clip or a custom video.",
    "noShootingBoard": "Shot has no shooting board — generate or upload it first.",
    "originalSeed": "Original seed: {{id}}",
    "originalShort": "Original: {{id}}",
    "originalSeedLabel": "Original:",
    "originalSeedHint": "By default the shot's original seed is used. The same seed is sent for all versions until you change it.",
    "seedOverrideHint": "Override is set; to restore the original seed, enter {{seed}}.",
    "seedMustBeInteger": "Seed must be an integer.",
    "transcribe": "Transcribe",
    "transcriptionSegmentHint": "Transcription of the animatic segment linked to the shot.",
    "pickCamera": "Pick camera",
    "clearCamera": "Clear camera",
    "cameraPresets": "Camera presets",
    "cameraPresetsChanged": "(changed)",
    "cameraPresetsHint": "Selected presets are passed to the system prompt during generation.",
    "promptsTitle": "Prompts",
    "promptsTitleFrame": "Frame prompts",
    "promptsTitleWithShot": "Prompts · shot {{number}}",
    "approxDurationSec": "≈ {{seconds}} s",
    "emptyOverridesHint": "Empty overrides = auto-assembly on the server.",
    "frameTab": "Frame",
    "videoTab": "Video",
    "referencesToApi": "References → API",
    "storyboardToApi": "Key frame → API",
    "requestText": "Request text",
    "artifactReady": "Artifact ready.",
    "trimmingInProgress": "Trimming in progress…",
    "trimFailed": "Trim failed — check segment is {{min}}–{{max}} s and save again. Audio modes need a source with an audio track.",
    "trimQueued": "A trim job will be queued after save.",
    "loadError": "Load error",
    "loadSettingsError": "Failed to save settings",
    "saveSeedError": "Failed to save seed",
    "transcriptionStartFailed": "Failed to start transcription",
    "uploadAnimaticButton": "Upload an animatic",
    "uploadingAnimatic": "Uploading… {{percent}}%",
    "replaceAnimatic": "Replace animatic",
    "replaceAnimaticTitle": "Replace the shot animatic?",
    "replaceAnimaticMessage": "The current animatic will be detached from the shot and replaced with the new one. No files are deleted — previous animatics stay in the library.",
    "replaceAnimaticConfirm": "Replace",
    "preparingAnimatic": "Preparing the animatic…"
  },
  "animaticRef": {
    "videoSilentTitle": "Video without sound (primary)",
    "videoSilentDesc": "Silent MP4 as reference_video. Most compatible option.",
    "downloadMp4": "Download MP4",
    "videoWithAudioTitle": "Video with sound",
    "videoWithAudioDesc": "Silent MP4 + MP3 as reference_audio for lip-sync and rhythm. Output audio follows the project Settings checkbox.",
    "downloadMp4WithAudio": "Download MP4 with sound (for preview)",
    "videoWithAudioExtra": "For studio preview; ARK receives silent clip + separate MP3.",
    "audioOnlyTitle": "Audio only",
    "audioOnlyDesc": "MP3 as reference_audio for lip-sync and rhythm; visuals — storyboard and regular reference images. Output audio follows the project Settings checkbox.",
    "downloadMp3": "Download MP3"
  },
  "placeholders": {
    "framePrompt": "Describe the frame. Type @ for characters, locations, props, and references.",
    "videoPrompt": "Describe motion and action. Type @ for characters, locations, props, and references.",
    "shootingBoardPrompt": "Describe the shooting board. Type @ for characters, locations, props, and references.",
    "intentSummary": "Describe what happens in the frame…",
    "correctionFrame": "For example: make the sky more overcast, add tree shadows…",
    "correctionVideo": "For example: remove camera shake at the end, make the sky slightly darker…",
    "correctionFrameLong": "For example: make the sky more overcast, add tree shadows, change lighting to evening…",
    "correctionVideoLong": "For example: remove camera shake at the end, make the sky slightly darker, fix artifact on hand…",
    "improveInstructions": "For example: enhance dramatic lighting, add more clothing detail, shorten to 3 sentences…",
    "searchNameRole": "Search by name / role…",
    "searchNameCategory": "Search by name / category…",
    "searchLocation": "Search location…",
    "searchByName": "Search by name…",
    "newCharacterName": "New character name",
    "newPropName": "New prop name",
    "generationId": "generation_id from OpenRouter"
  },
  "edit": {
    "title": "Shot {{label}}",
    "descriptionLabel": "Shot description",
    "sceneLabel": "Scene",
    "sceneHint": "The shot will become the last in the selected scene and get a new number.",
    "sceneSearchPlaceholder": "Search scenes…",
    "movedToast": "Shot moved: {{label}}",
    "moveFailed": "Could not move the shot",
    "toggleVisibilityFailed": "Failed to change visibility ({{status}})",
    "deleteFailed": "Failed to delete shot ({{status}})"
  },
  "improvePrompt": {
    "titleStoryboard": "Improve frame prompt",
    "titleVideo": "Improve video prompt",
    "description": "Specify how to improve the prompt. Leave empty for standard model improvement.",
    "instructionsLabel": "Additional instructions",
    "includeTranscription": "Include animatic transcription",
    "transcriptionUnavailable": "Transcription unavailable for this shot — block will not be sent.",
    "transcriptionHint": "Transcription is passed in system_prompt as scene context (lines, actions, timing)."
  },
  "promptVersions": {
    "titleStoryboard": "Frame prompt history",
    "titleVideo": "Video prompt history",
    "loading": "Loading…",
    "empty": "No versions yet. Save the prompt to create a version.",
    "source": {
      "manual": "Saved",
      "improver": "Improvement",
      "default": "Default",
      "generation": "Generation"
    },
    "active": "Active",
    "insertIntoField": "Insert into field",
    "makeActive": "Make active",
    "doubleClickActivate": "Double-click to make active"
  },
  "mediaVersionPrompt": {
    "title": "Version prompt",
    "promptLabel": "Prompt",
    "makeActive": "Make active"
  },
  "characters": {
    "title": "Characters",
    "dialogTitle": "Frame characters {{label}}",
    "dialogDescription": "Select shot participants and outfit if needed. A character not in the scene cast will be added automatically on save.",
    "hint": "Mark characters present in the frame.",
    "noPeople": "Frame without people",
    "noPeopleHint": "Storyboard and video prompts will forbid people; character references will not be sent to generation.",
    "noMatching": "No matching characters in the project. Add one below.",
    "useVoice": "Use voice",
    "includeDescription": "Description in prompt",
    "useVoiceNotReady": "The character has no ready active voice. Set up a voice on the character card.",
    "useVoiceProviderUnsupported": "Voice references are supported only by Seedance video generation.",
    "useVoiceLimit": "Limit reached: at most {{max}} voice references per shot (Seedance restriction).",
    "quickAdd": "Quick add character",
    "add": "Add",
    "defaultOutfit": "Default outfit",
    "charactersSection": "Shot characters",
    "recognized": "({{count}} recognized)",
    "noCharacters": "No characters.",
    "openImage": "Open image “{{name}}”",
    "charactersLink": "Characters section"
  },
  "props": {
    "title": "Props",
    "hint": "Mark the props present in the frame.",
    "noMatching": "No matching props in the project. Add a new one below.",
    "quickAdd": "Quick add prop",
    "add": "Add",
    "baseState": "Base state",
    "openImage": "Open image “{{name}}”"
  },
  "location": {
    "title": "Location",
    "dialogTitle": "Frame location {{label}}",
    "dialogDescription": "Select location, variant, and reference angle. One frame — one location.",
    "hint": "Select location and angle for the frame.",
    "saved": "Location saved",
    "saveFailed": "Failed to save location",
    "loadError": "Load error",
    "noLocations": "No locations in the project.",
    "nothingFound": "Nothing found.",
    "facingSection": "Facing (reference)",
    "facingGroup": "Facing",
    "facingWithRef": "{{name}} · reference available",
    "facingNoRef": "{{name}} · no reference",
    "facingLoaded": "{{name}}, reference loaded",
    "facingMissing": "{{name}}, no reference",
    "facingHint": "Angle is set after choosing location and variant. Missing basic views fall back to the 3/4 reference. Without a location the server uses north.",
    "angles": {
      "basic": "Basic angles",
      "photographed": "Additional angles"
    },
    "saveAsPrimaryFacing": "New location is saved as the primary 3/4 reference.",
    "openLocationImage": "Open location image “{{name}}”",
    "openImage": "Open image “{{name}}”",
    "noLocation": "No location",
    "locationsLink": "Locations section",
    "recognized": "(recognized: {{name}})",
    "shotLocation": "Shot location",
    "facing": {
      "three_quarter": "Three-quarter",
      "topview": "Top view",
      "north": "North",
      "east": "East",
      "south": "South",
      "west": "West",
      "short": {
        "three_quarter": "3/4",
        "topview": "Top"
      },
      "letter": {
        "north": "N",
        "east": "E",
        "south": "S",
        "west": "W"
      }
    }
  },
  "correction": {
    "frameTitle": "Frame correction",
    "videoTitle": "Correction",
    "frameDescription": "Describe what to change — a new version will be generated from the current frame.",
    "videoDescription": "Describe what to change — a new version will be generated from the current video. Specify intervals in seconds (e.g. 0–2 s, from 3 s to end).",
    "whatToChange": "What to change in the video",
    "startCorrection": "Start correction",
    "startFailed": "Failed to start correction.",
    "correctFailed": "Failed to correct frame.",
    "queueFailed": "Failed to queue correction.",
    "loadingVersions": "Loading versions…",
    "noVideoVersion": "No video version for correction.",
    "correctionSource": "Correction source",
    "active": "Active",
    "clipForCorrection": "Clip for correction",
    "noPreviewUrl": "No preview URL",
    "versionFrames": "First and last frame of version",
    "framesNotExtracted": "Frames not extracted for this version",
    "firstFrameUnavailable": "First frame unavailable",
    "lastFrameUnavailable": "Last frame unavailable",
    "timelineMarkers": "Timeline markers",
    "markups": "Frame markups",
    "addMarkup": "Save markup",
    "markupCap": "{{count}} / {{max}}",
    "markupMentionHint": "Type @ to mention a saved markup by timecode",
    "captureUnavailable": "Local video is required to save a markup for this version."
  },
  "preview": {
    "loadFailed": "Failed to load shot data.",
    "uploadShootingBoardFailed": "Failed to upload shooting board.",
    "uploadFrameFailed": "Failed to upload frame.",
    "uploadVideoFailed": "Failed to upload video.",
    "videoTransitionNotGenerated": "Transition video not generated yet.",
    "videoNotGenerated": "Video not generated yet.",
    "transitionFramesNotReady": "Transition frames not ready yet.",
    "storyboardNotGenerated": "Key frame not generated yet.",
    "shootingBoardNotCreated": "Shooting board not created yet.",
    "storyboardFromPrevShot": "Frame from shot {{label}}",
    "storyboardFromPrevShotHint": "Replace the key frame with the last frame of shot {{label}} video",
    "storyboardFromPrevShotFailed": "Could not update the key frame.",
    "storyboardFromLibrary": "From library",
    "storyboardFromLibraryHint": "Pick the key frame from the frame library",
    "storyboardFromLibraryFailed": "Could not set the frame from the library.",
    "shootingBoardFromLibrary": "From library",
    "shootingBoardFromLibraryHint": "Pick the shooting board from the frame library",
    "shootingBoardFromLibraryFailed": "Could not set the shooting board from the library.",
    "videoFromLibrary": "From library",
    "videoFromLibraryHint": "Pick a video from the library",
    "videoFromLibraryFailed": "Could not set the video from the library.",
    "pickFromLibrary": "Pick from library",
    "leftShotLastFrame": "Last frame of left shot",
    "rightShotFirstFrame": "First frame of right shot"
  },
  "transcription": {
    "title": "Segment transcription",
    "loadFailed": "Failed to load data",
    "approveFailed": "Approval error",
    "networkError": "Network error",
    "notDone": "Transcription for this shot has not been run yet. Start transcription of the animatic segment linked to this shot.",
    "environment": "Environment",
    "lighting": "Light: {{value}}",
    "charactersFromVideo": "Characters from video",
    "dialogues": "Dialogues",
    "editablePrompts": "Prompts (editable)",
    "firstFramePrompt": "First frame prompt",
    "videoPrompt": "Video prompt",
    "approved": "Approved — characters, location, and prompts updated.",
    "apply": "Apply characters, location, and prompts",
    "noLocations": "No locations."
  },
  "references": {
    "openOriginal": "Open original",
    "openCharacters": "Open characters",
    "openProps": "Open props",
    "openLocation": "Open location",
    "characters": "Characters",
    "props": "Props",
    "location": "Location",
    "scene3d": "3D scene",
    "openScene3d": "Open 3D scene",
    "kindCharacter": "character",
    "kindProp": "prop",
    "kindLocation": "location",
    "appearanceUpdated": "The hero's sheet was updated after the last generation — regenerate the shot",
    "propAppearanceUpdated": "The prop image was updated after the last generation — regenerate the shot"
  },
  "referenceInputs": {
    "title": "Shot custom references",
    "addToPrompt": "Add to prompt",
    "removeConfirm": "Remove reference {{label}}?",
    "removeConfirmUsed": "Prompt contains {{label}}. Remove reference anyway? The number is not reused — update the prompt text if needed.",
    "sendStoryboardFrame": "Send storyboard frame to API",
    "skipStoryboardFrame": "Do not send storyboard frame to API",
    "voiceReferenceTitle": "Voice of {{name}}",
    "addFromLibrary": "From library",
    "attach": "Attach",
    "addFromLibraryFailed": "Could not add the reference from the library.",
    "addFromLibraryPartial": "Could not add: {{names}}"
  },
  "mediaVersions": {
    "storyboard": "Frame versions",
    "storyboardModal": "Storyboard versions",
    "shooting_board": "Shooting board",
    "shooting_boardModal": "Shooting board versions",
    "video": "Video versions",
    "loadFailed": "Failed to load versions.",
    "activateFailed": "Failed to activate version.",
    "qualitySaveFailed": "Failed to save mark.",
    "uploadFrameFailed": "Failed to upload frame.",
    "uploadShootingBoardFailed": "Failed to upload shooting board.",
    "uploadVideoFailed": "Failed to upload video.",
    "noShotInResponse": "Server response missing shot data",
    "modalSubtitle": "Shot {{scene}}.{{number}} — select active version for workspace page.",
    "doubleClickHint": "Double-click a version to make it current.",
    "backToVersions": "Back to versions",
    "apiRequest": "API request",
    "provider": "Provider",
    "model": "Model",
    "endpoint": "Endpoint",
    "status": "Status",
    "time": "Time",
    "date": "Date",
    "error": "Error",
    "checkGeneration": "Check generation",
    "checkGenerationHint": "If generation completed successfully in OpenRouter Dashboard, paste its ID and click Check. The image will be downloaded and saved as a storyboard frame.",
    "check": "Check",
    "enterGenerationId": "Enter generation_id.",
    "imageSaved": "Image saved.",
    "imageNotFound": "Image not found.",
    "noPreview": "No preview",
    "current": "Current",
    "apiRequestTitle": "API request",
    "versionPrompt": "Version prompt",
    "promptNotSaved": "Prompt not saved for this version (new generations only)",
    "makeCurrent": "Make current",
    "makeCurrentEllipsis": "…",
    "previewTitle": "{{name}}",
    "doubleClickActivate": "Double-click to make current",
    "empty": "No saved versions yet.",
    "fromVideoPrompt": "From video prompt",
    "fromVideoPromptTitle": "Generate from video prompt text (project image provider)",
    "copyOriginalToClipboard": "Copy original to clipboard",
    "logStatus": {
      "pending": "Preparing",
      "sent": "Sent",
      "succeeded": "Succeeded",
      "failed": "Failed",
      "abandoned": "Abandoned",
      "cancelled": "Cancelled"
    }
  },
  "details": {
    "title": "Shot {{number}}",
    "titleFallback": "Frame",
    "description": "All saved shot fields and raw LLM JSON. To refresh prompts from n8n, regenerate scene shots or all project shots — shot records keep their ids.",
    "projectTree": "Project tree context",
    "season": "Season {{number}}",
    "episode": "Episode {{number}}",
    "scene": "Scene {{number}}",
    "projectLocation": "Project location:",
    "idsAndStatus": "IDs and status",
    "cameraPreset": "camera preset: {{name}}",
    "locationVariant": "location variant:",
    "targetDuration": "target duration: {{seconds}}s",
    "charactersBinding": "Characters (shot binding)",
    "intentSummary": "Frame purpose (intent_summary)",
    "notSet": "not set",
    "userVisiblePrompt": "Frame prompt (user_visible_prompt_summary)",
    "llmFieldsGlue": "LLM fields glue (description, visual_details, camera…)",
    "storyboardVideo": "Storyboard / video (URLs and prompts)",
    "storyboardPreview": "storyboard preview:",
    "none": "none",
    "clip": "clip:",
    "systemPromptOverride": "System prompt (override / default)",
    "overrideEmptyDefault": "override empty — storyboard page will use default.",
    "defaultSystem": "Default system",
    "klingPromptOverride": "Kling frame prompt (override / default)",
    "overrideEmptyAuto": "override empty — auto-assembly will be used.",
    "defaultFramePrompt": "Default frame prompt",
    "llmExtras": "llm_extras (raw JSON)",
    "empty": "empty"
  },
  "promptEditor": {
    "defaultAriaLabel": "Prompt",
    "wrapSegmentTitle": "Wrap current line in segment",
    "segment": "+segment",
    "mentionHint": "Type @ for characters, locations, props, and references",
    "blockTimecode": "Block timecode",
    "removeBlock": "Remove block",
    "segmentCamera": "Camera not selected",
    "pickSegmentCamera": "Pick camera for this segment",
    "clearSegmentCamera": "Clear segment camera",
    "pinnedGroup": "Linked to shot",
    "category": {
      "hero": "Characters",
      "loc": "Locations",
      "prop": "Props",
      "shot": "Shots",
      "reference": "References",
      "cam": "Cameras",
      "attr": "Attributes",
      "file": "Files",
      "person": "People",
      "task": "Tasks",
      "script": "Script",
      "node": "Nodes",
      "img": "Images",
      "vid": "Videos"
    },
    "nothingFound": "Nothing found",
    "propBase": "base",
    "videoMedia": "video",
    "audioMedia": "audio",
    "mention": {
      "remove": "Remove",
      "replace": "Replace",
      "open": "Open",
      "missingFile": "@file removed"
    }
  },
  "postProduction": {
    "action": "Processing",
    "launchTitle": "Processing",
    "launchDescription": "Choose a processing model, tune parameters, and create a derived video version.",
    "loadingModels": "Loading processing models…",
    "loadModelsFailed": "Failed to load processing models",
    "loadVersionsFailed": "Failed to load processing versions",
    "startFailed": "Failed to start processing",
    "actionFailed": "Processing action failed",
    "noSource": "Select or generate a video version first.",
    "noModels": "No active processing models.",
    "version": "Version",
    "noVersion": "No version",
    "parameters": "Parameters",
    "noParameters": "This model has no configurable parameters.",
    "parameterLabels": {
      "upscale_factor": "Upscale"
    },
    "parameterOptions": {
      "upscale_factor": {
        "1": "1×",
        "2": "2×",
        "4": "4×"
      }
    },
    "parameterHint": {
      "decimalBetween": "Decimal between {{min}} and {{max}}",
      "integerBetween": "Integer between {{min}} and {{max}}"
    },
    "parameterValidation": {
      "required": "This parameter is required.",
      "invalid": "Invalid value.",
      "invalidEnum": "Choose one of the allowed values.",
      "mustBeInteger": "Must be a whole number.",
      "mustBeNumber": "Must be a number.",
      "belowMinimum": "Must be at least {{min}}.",
      "aboveMaximum": "Must be at most {{max}}.",
      "belowMinLength": "Must be at least {{min}} characters.",
      "aboveMaxLength": "Must be at most {{max}} characters.",
      "patternMismatch": "Must match the required format."
    },
    "defaultParameter": "Default",
    "enabledParameter": "Enabled",
    "unsupportedParameterType": "Unsupported type: {{type}}",
    "sourceVersion": "Source video version #{{id}}",
    "start": "Start processing",
    "largeOutputConfirm": {
      "title": "Video larger than 4K",
      "message": "You are about to render a video of roughly {{width}}×{{height}}. This is a very large file and an expensive generation. Continue?",
      "confirm": "Start anyway"
    },
    "queued": "Processing queued",
    "panelTitle": "Processing versions",
    "panelHint": "Derived videos for the selected shot video version.",
    "panelHintWithSource": "Derived videos from video version #{{id}}.",
    "empty": "No processing versions for this source yet.",
    "reset": "Use source video",
    "original": "Original",
    "originalHint": "Source video without processing",
    "current": "Current",
    "use": "Use",
    "doubleClickUse": "Double-click a result to use it as current shot video.",
    "deleteConfirm": "Delete this processing version?",
    "status": {
      "queued": "Queued",
      "processing": "Processing",
      "done": "Done",
      "failed": "Failed"
    }
  },
  "frameCaptures": {
    "title": "Screenshots",
    "captureHint": "Capture frame at current position",
    "captureFailed": "Failed to capture the frame.",
    "deleteConfirm": "Delete this screenshot?",
    "deleteFailed": "Failed to delete the screenshot.",
    "delete": "Delete screenshot",
    "failed": "Failed"
  },
  "apiErrors": {
    "loadShotFailed": "Failed to load shot data ({{status}})",
    "saveFailed": "Save failed ({{status}})",
    "noShotInResponse": "Server response missing shot data",
    "loadStoryFailed": "Failed to load story text ({{status}})",
    "loadCastFailed": "Failed to load cast ({{status}})",
    "loadPropsFailed": "Failed to load props ({{status}})",
    "loadLocationsFailed": "Failed to load locations ({{status}})",
    "linkSegmentFailed": "Failed to link segment ({{status}})",
    "loadSiblingsFailed": "Failed to load sibling shots ({{status}})",
    "loadPromptVersionsFailed": "Failed to load prompt versions ({{status}})",
    "loadMediaVersionsFailed": "Failed to load versions ({{status}})",
    "activatePromptVersionFailed": "Failed to activate prompt version ({{status}})",
    "improvePromptFailed": "Failed to improve prompt ({{status}})",
    "unlinkSegmentFailed": "Failed to unlink segment ({{status}})",
    "loadTranscriptionsFailed": "Failed to load transcriptions ({{status}})",
    "activateTranscriptionFailed": "Failed to activate transcription ({{status}})",
    "uploadAnimaticFailed": "Failed to upload the animatic ({{status}})"
  },
  "frameLibrary": {
    "assignStoryboard": "Set as key frame",
    "assignShootingBoard": "Set as shooting board",
    "assignVideo": "Set as shot video",
    "subtitleStoryboard": "Key frame · Shot {{number}}",
    "subtitleShootingBoard": "Shooting board · Shot {{number}}",
    "subtitleVideo": "Video · Shot {{number}}",
    "subtitleAnimatic": "Animatic · Shot {{number}}",
    "subtitlePreviz": "Previz · Shot {{number}}"
  },
  "transitionFrames": {
    "manual": "manual",
    "pick": "Pick a frame",
    "reset": "Auto",
    "resetHint": "Go back to the neighbouring shot frame",
    "assignLeft": "Set as left frame",
    "assignRight": "Set as right frame",
    "subtitleLeft": "Transition left frame · Shot {{number}}",
    "subtitleRight": "Transition right frame · Shot {{number}}",
    "assignFailed": "Could not set the transition frame.",
    "resetFailed": "Could not restore the automatic frame."
  },
  "assetShelf": {
    "versionLabel": "v{{n}}",
    "makeActive": "Make primary: v{{n}} · {{date}}",
    "activeVersion": "Primary version v{{n}}",
    "generatingVersionN": "Generating v{{n}} · {{progress}}%",
    "allVersions": "All versions ({{count}})",
    "references": "References",
    "referencesCount": "References: {{count}}",
    "refsTitleVideo": "What goes into video generation",
    "refsTitleFrame": "What goes into frame generation",
    "previz": "Previz",
    "animatic": "Animatic",
    "none": "None",
    "original": "Original",
    "depthGray": "Depth B/W",
    "depthColor": "Depth color",
    "animSilent": "No sound",
    "animWithAudio": "With sound",
    "animAudioOnly": "Sound only",
    "currentFrame": "Current frame as reference",
    "currentFrameHint": "Edit on top of what is there",
    "animaticFrame": "Frame from animatic",
    "animaticFrameHint": "Composition only: B/W sketch",
    "motionExclusiveHint": "Previz and animatic drive the camera through one video reference — pick one.",
    "savedOnGenerate": "Saved with the prompt when you generate.",
    "noPreviz": "No previz linked to the shot",
    "noAnimatic": "Shot is not linked to the animatic",
    "depthNotReady": "Compute the depth mask on the Previz tab first",
    "previzTooLong": "Previz is longer than the video reference limit",
    "summaryPreviz": "previz",
    "summaryDepth": "depth",
    "summaryAnimatic": "animatic",
    "summaryCurrent": "current frame",
    "sendToVideo": "Send to video as",
    "postProductionApplied": "Processed version",
    "currentVideo": "Current video as reference",
    "currentVideoHint": "Motion, timing and staging of the previous take",
    "noCurrentVideo": "The shot has no video yet",
    "summaryCurrentVideo": "current video",
    "motionExclusiveHintWithVideo": "Current video, previz and animatic drive motion through one video reference — pick one.",
    "ctxStoryboardFrame": "Key frame",
    "ctxStoryboardFrameName": "first frame of the video",
    "ctxOwnRefs": "Own references",
    "ctxHeroes": "Heroes",
    "ctxProps": "Props",
    "ctxLocation": "Location",
    "generateDepth": "Generate depth mask",
    "changeFrameModel": "Change frame model",
    "modelSearch": "Find a model",
    "modelFromProject": "Same as project",
    "modelNothingFound": "Nothing found",
    "modelOverriddenHint": "Shot’s own model. Project uses {{project}}",
    "audio": "Video sound",
    "audioOnHint": "The video will have sound. Click for no sound.",
    "audioOffHint": "The video will be silent. Click to add sound.",
    "audioDiffersHint": "Shot’s own setting; the project uses the opposite."
  }
}
